// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { linkListStyles } from "@turnerBlueprint/Overrides/Widgets/Basic/SocialLinks";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { color, getSystemColor } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

linkListStyles.socialLinkListWrapper = {
    css: css`
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 12px;
    `,
};

linkListStyles.linkWrapper = {
    css: css`
        &&& {
            display: flex;
            flex: 0;
            padding: 0;
            margin: 0;
            ${IconWrapper}, svg {
                margin: 0;
            }
        }
    `,
};

linkListStyles.link = {
    css: css`
        gap: 10px;
        align-items: flex-start;
        &:hover ${IconWrapper}, &:hover ${TypographyStyle} {
            color: ${color("common.ui9")};
        }
    `,
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.bold,
        lineHeight: "16px",
        css: css`
            &:empty {
                display: none;
            }
            &&& {
                color: ${({ labelColor }: any) => labelColor || getSystemColor("common.white")};
            }
            ${TypographyStyle} {
                line-height: 16px;
                font-size: 14px;
                margin: 0;
            }
        `,
    },
};

linkListStyles.title = {
    variant: "h5",
    forwardAs: "p",
    color: "common.white",
};
